export default {
  TOGGLE_LOADING (state) {
    state.callingAPI = !state.callingAPI
  },
  TOGGLE_SEARCHING (state) {
    state.searching = (state.searching === '') ? 'loading' : ''
  },
  SET_USER (state, user) {
    state.user = user
  },
  SET_TOKEN (state, token) {
    state.token = token
  },
  SET_TOKEN_VALID_AT (state, validAt) {
    state.tokenValidAt = validAt
  },
  SET_PROJECT (state, projects) {
    state.userInfo.projects = projects
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js